import { Storage } from '../lib/storage';
import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Crown, ShieldCheck, Zap, Users, CheckCircle, Ticket, AlertTriangle, X } from 'lucide-react';
import { supabase } from '../lib/supabase';
export default function MembresiaScreen({ onClose }: { onClose: () => void }) {
  const [codigoAfiliado, setCodigoAfiliado] = useState('');
  const [youtuberDetectado, setYoutuberDetectado] = useState<string | null>(null);
  const [pagando, setPagando] = useState(false);
  const [comprado, setComprado] = useState(false);
  const [dialogoConfirmacion, setDialogoConfirmacion] = useState<{titulo: string, mensaje: string, color: 'emerald' | 'amber' | 'red'} | null>(null);

  // Simula la base de datos de Afiliados
  const verificarCodigo = async () => {
    const code = codigoAfiliado.toUpperCase().trim();
    if (code.length < 3) {
      setDialogoConfirmacion({
        titulo: "SISTEMA DE AFILIADOS",
        mensaje: "⚠️ MESA DE CONTROL: Ingresa un código válido de al menos 3 letras para validar tu descuento.",
        color: 'amber'
      });
      return;
    }
    
    // Consulta Real a la Base de Datos de Embajadores
    const { data: creatorData, error } = await supabase
      .from('afiliados_creadores')
      .select('nombre_creador, estado')
      .eq('codigo_promocional', code)
      .single();

    if (error || !creatorData || creatorData.estado !== 'ACTIVO') {
      setDialogoConfirmacion({
        titulo: "CÓDIGO INVÁLIDO",
        mensaje: "⚠️ MESA DE CONTROL: El código de referido ingresado no existe o no se encuentra activo.",
        color: 'amber'
      });
      setYoutuberDetectado(null);
    } else {
      setYoutuberDetectado(code);
    }
  };

  const simularPago = () => {
    setPagando(true);
    setTimeout(async () => {
      const uid = Storage.get('gravity_user_id') || '';
      
      Storage.set('pikis_last_checkout_app', 'gravity_oro');
      Storage.set('gravity_oro_buyer_id', uid);
      if (youtuberDetectado) {
        Storage.set('gravity_oro_youtuber', youtuberDetectado);
      }
      
      // Lógica de ruteo de pago
      if (youtuberDetectado) {
        // Enlace de Mercado Pago por $25.000
        window.location.href = 'https://mpago.li/2ueeHdD';
      } else {
        // Enlace normal de $30.000
        window.location.href = 'https://mpago.li/2PGBUT1';
      }
    }, 1000);
  };

  if (comprado) {
    return (
      <motion.div 
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }} 
        className="fixed inset-0 z-[300] bg-black flex flex-col items-center justify-center p-6 text-center"
      >
        <Crown className="w-24 h-24 text-gold-cert mb-6 animate-pulse" />
        <h2 className="text-3xl font-black mb-2 text-white">¡Eres SCORE ORO!</h2>
        <p className="text-sm text-text-muted mb-8 leading-relaxed max-w-xs">
          Tu bicicleta ahora cuenta con trazabilidad inmutable certificada. Tienes acceso prioritario al botón S.O.S nacional y acceso total al BikeMarket VIP.
        </p>
        
        {youtuberDetectado && (
          <div className="bg-green-500/10 border border-green-500/30 p-4 rounded-xl mb-8 flex items-center gap-3">
            <CheckCircle className="w-6 h-6 text-green-400 shrink-0" />
            <p className="text-xs text-left text-green-100 font-medium">
              ¡Gracias! Parte de tu compra apoya directamente al creador <strong>@{youtuberDetectado}</strong>.
            </p>
          </div>
        )}

        <button 
          onClick={onClose}
          className="w-full py-4 bg-gold-cert text-yellow-950 font-black rounded-xl hover:scale-105 transition-transform"
        >
          Volver a mi Garaje
        </button>
      </motion.div>
    );
  }

  return (
    <>
    <motion.div 
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      className="fixed inset-0 z-[300] bg-black flex flex-col overflow-y-auto scrollbar-hide"
    >
      <div className="relative h-56 bg-gradient-to-b from-yellow-700/20 to-black flex flex-col items-center justify-center pt-8">
        <button onClick={onClose} className="absolute top-6 right-6 text-white/50 hover:text-white">✕ Cerrar</button>
        <div className="w-16 h-16 bg-gradient-to-tr from-yellow-500 to-yellow-200 rounded-full flex items-center justify-center p-1 mb-3 shadow-[0_0_30px_rgba(251,191,36,0.3)]">
          <div className="w-full h-full bg-bg-dark rounded-full flex items-center justify-center">
            <Crown className="w-8 h-8 text-gold-cert" />
          </div>
        </div>
        <h1 className="text-xl font-black tracking-tight text-white text-center px-4 leading-tight">
          Certificación <span className="text-gold-cert">Premium ORO</span>
        </h1>
        <p className="text-text-muted text-[10px] mt-1">El nivel VIP para tu bicicleta.</p>
      </div>

      <div className="px-6 -mt-4 pb-6">
        <div className="bg-[#050505] rounded-3xl p-5 border border-white/10 shadow-[0_10px_40px_rgba(0,0,0,0.8)] relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold-cert/5 rounded-full blur-3xl -mr-10 -mt-10"></div>
          
          <div className="flex flex-col items-center justify-center mb-5 mt-2">
            {youtuberDetectado && (
               <div className="text-danger-red font-black text-sm line-through decoration-danger-red decoration-2 mb-1 opacity-80 flex items-center gap-1">
                 <span className="text-xs">$</span>30.000
               </div>
            )}
            <div className="flex items-end gap-1">
              <span className="text-sm font-bold text-text-muted pb-1">$</span>
              <span className={`text-4xl font-black tracking-tighter leading-none ${youtuberDetectado ? 'text-green-400 drop-shadow-[0_0_10px_rgba(74,222,128,0.4)] scale-110 transition-transform' : 'text-white'}`}>
                {youtuberDetectado ? '25.000' : '30.000'}
              </span>
              <span className="text-[10px] font-black text-text-muted pb-1 tracking-widest uppercase">/ DOS AÑOS</span>
            </div>
            {youtuberDetectado && (
               <div className="bg-green-500 text-bg-dark text-[10px] font-black uppercase px-3 py-1 rounded-full mt-2 animate-pulse shadow-[0_0_10px_rgba(34,197,94,0.5)]">
                 ¡ZONA VIP! Ahorraste $5.000 COP
               </div>
            )}
          </div>

          <div className="space-y-3 mb-5">
            <div className="flex items-start gap-3">
              <ShieldCheck className="w-5 h-5 text-green-400 shrink-0 mt-0.5" />
              <div>
                <strong className="block text-sm text-white">Muro Bike VIP</strong>
                <span className="text-[11px] text-text-muted leading-tight">Comparte tus mejores bajadas y armados en el feed social. Obtén mayor visibilidad y respeto en la comunidad.</span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Zap className="w-5 h-5 text-primary-cyan shrink-0 mt-0.5" />
              <div>
                <strong className="block text-sm text-white">Prioridad S.O.S (Ping Nacional)</strong>
                <span className="text-[11px] text-text-muted leading-tight">Alerta geolocalizada que notifica a todos los pilotos en un radio de 5km de forma prioritaria.</span>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Users className="w-5 h-5 text-gold-cert shrink-0 mt-0.5" />
              <div>
                <strong className="block text-sm text-white">BikeMarket VIP Ilimitado</strong>
                <span className="text-[11px] text-text-muted leading-tight">Publica y negocia tus bicicletas o componentes sin restricciones ni comisiones ocultas.</span>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-4">
            <label className="text-[9px] font-bold uppercase tracking-widest text-text-muted mb-1.5 flex items-center gap-1.5">
              <Ticket className="w-3 h-3" /> ¿Te invitó un Creador de Contenido?
            </label>
            <div className="flex gap-2 w-full">
              <input 
                type="text" 
                placeholder="Código Afiliado"
                value={codigoAfiliado}
                onChange={e => setCodigoAfiliado(e.target.value)}
                disabled={youtuberDetectado !== null}
                className="flex-1 min-w-0 bg-black/30 border border-slate-700 rounded-lg px-3 py-2 text-[12px] font-black uppercase tracking-widest outline-none focus:border-gold-cert disabled:opacity-50"
              />
              {!youtuberDetectado && (
                <button 
                  onClick={verificarCodigo}
                  className="bg-primary-cyan text-bg-dark font-black px-4 py-2 rounded-lg hover:bg-cyan-400 transition-colors shadow-[0_0_10px_rgba(0,168,255,0.3)] text-[10px] uppercase tracking-widest shrink-0"
                >
                  Canjear
                </button>
              )}
            </div>
            
            <AnimatePresence>
              {youtuberDetectado && (
                <motion.div initial={{ opacity:0, height:0 }} animate={{ opacity:1, height:'auto' }} className="mt-3 flex items-center justify-between border border-green-500/30 bg-green-500/10 rounded-lg p-2">
                  <p className="text-[11px] text-green-400 font-bold uppercase tracking-wider flex items-center gap-1">
                    <CheckCircle className="w-3.5 h-3.5" /> Código <strong>{youtuberDetectado}</strong> Activo.
                  </p>
                  <button onClick={() => setYoutuberDetectado(null)} className="text-[10px] text-slate-400 hover:text-white underline">Remover</button>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>

        <button 
          onClick={simularPago}
          disabled={pagando}
          className={`w-full mt-4 py-4 font-black uppercase tracking-widest text-[13px] rounded-xl active:scale-95 transition-all flex justify-center items-center gap-2 shadow-[0_0_20px_rgba(251,191,36,0.3)] hover:shadow-[0_0_30px_rgba(251,191,36,0.5)] ${youtuberDetectado ? 'bg-green-500 text-bg-dark' : 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-yellow-950'}`}
        >
          {pagando ? 'PROCESANDO PAGO SEGURO...' : (youtuberDetectado ? 'PAGAR $25.000 CON DESCUENTO' : 'ADQUIRIR SCORE ORO')}
        </button>
      </div>
    </motion.div>
    
    {/* SISTEMA DE ALERTAS LOCAL ORO */}
    <AnimatePresence>
      {dialogoConfirmacion && (
        <motion.div 
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[500] bg-black/80 backdrop-blur-md flex items-center justify-center p-6"
        >
          <motion.div 
            initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.9, y: 20 }}
            className={`w-full max-w-xs bg-slate-900 border ${dialogoConfirmacion.color === 'amber' ? 'border-yellow-500/30' : 'border-red-500/30'} rounded-3xl p-6 text-center shadow-[0_0_50px_rgba(0,0,0,0.5)] relative overflow-hidden`}
          >
            {dialogoConfirmacion.color === 'amber' && <div className="absolute top-0 left-0 w-full h-1 bg-yellow-500 opacity-50"></div>}
            
            <div className={`w-16 h-16 ${dialogoConfirmacion.color === 'amber' ? 'bg-yellow-500/10 border-yellow-500/20' : 'bg-red-500/10 border-red-500/20'} rounded-full flex items-center justify-center mx-auto mb-4 border shadow-inner`}>
              <AlertTriangle className={`w-8 h-8 ${dialogoConfirmacion.color === 'amber' ? 'text-yellow-500' : 'text-red-500'}`} />
            </div>
            <h3 className="text-white font-black text-lg mb-2 uppercase tracking-wide">{dialogoConfirmacion.titulo}</h3>
            <p className="text-slate-400 text-[12px] font-medium leading-relaxed mb-6">{dialogoConfirmacion.mensaje}</p>
            
            <button 
              onClick={() => setDialogoConfirmacion(null)}
              className={`w-full py-3 ${dialogoConfirmacion.color === 'amber' ? 'bg-yellow-600 hover:bg-yellow-500 shadow-[0_0_15px_rgba(234,179,8,0.4)]' : 'bg-red-500 hover:bg-red-600'} text-white rounded-xl font-black text-[11px] uppercase tracking-wider active:scale-95 transition-all`}
            >
              Entendido
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
    </>
  );
}
